import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// ==================== 导航首页 ====================
const NavHome = () => import('@/views/NavHome.vue')

// ==================== Big 原有视图 ====================
const bigHome = () => import('@/views/Home.vue')
const bigNotFound = () => import('@/views/NotFound.vue')

// ==================== Big1 视图 ====================
const big1About2 = () => import('@/views/big1/About2.vue')

// ==================== Big2 视图 ====================
const big2About = () => import('@/views/big2/About.vue')

// ==================== Big3 视图 ====================
const big3About = () => import('@/views/big3/About.vue')

// ==================== 河南业绩大屏 视图 ====================
const hnyjdzHome = () => import('@/views/hnyjdz/index.vue')

// ==================== 商业大屏 视图 ====================
const sydmKel = () => import('@/views/sydm/kel.vue')

const routes = [
  // ==================== 导航首页 ====================
  {
    path: '/',
    name: 'navHome',
    component: NavHome,
  },

  // ==================== Big 路由 ====================
  {
    path: '/big/home',
    name: 'bigHome',
    component: bigHome,
  },

  // ==================== Big1 路由 ====================
  {
    path: '/big1/about2',
    name: 'big1About2',
    component: big1About2,
  },
  // ==================== Big2 路由 ====================
  {
    path: '/big2/about',
    name: 'big2About',
    component: big2About,
  },
  // ==================== Big3 路由 ====================
  {
    path: '/big3/about',
    name: 'big3About',
    component: big3About,
  },
  // ==================== 河南业绩大屏 路由 ====================
  {
    path: '/hnyjdz/home',
    name: 'hnyjdzHome',
    component: hnyjdzHome,
  },

  // ==================== 商业大屏 路由 ====================
  {
    path: '/sydm/kel',
    name: 'sydmKel',
    component: sydmKel,
  },
  // ==================== 404 兜底 ====================
  {
    path: '*',
    name: 'NotFound',
    component: bigNotFound,
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
